var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#92909A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45797 15.8695C7.26271 16.0647 7.26271 16.3813 7.45797 16.5766C7.65323 16.7718 7.96982 16.7718 8.16508 16.5766L11.8706 12.8711L15.5767 16.5772C15.772 16.7724 16.0886 16.7724 16.2838 16.5772C16.4791 16.3819 16.4791 16.0653 16.2838 15.8701L12.5777 12.164L16.3882 8.35343C16.5835 8.15817 16.5835 7.84159 16.3882 7.64632C16.193 7.45106 15.8764 7.45106 15.6811 7.64632L11.8706 11.4568L8.06066 7.6469C7.8654 7.45164 7.54882 7.45164 7.35355 7.6469C7.15829 7.84216 7.15829 8.15874 7.35355 8.35401L11.1635 12.164L7.45797 15.8695Z",
    fill: "#92909A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.cd0c907d101b904211cef6f96e18820c.svg";
export { ForwardRef as ReactComponent };